export default "__VITE_ASSET__DsA2WgRX__"